import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const ReportDetailsStudentViewLazy = React.lazy(
	() =>
		import(/* webpackChunkName : 'ReportDetailsStudentView' */ './components')
);

export default (store) => {
	return {
		path: 'report-configure/progress-reports/:campusId/student-view/:reportRunId',
		element: <AsyncLoading component={<ReportDetailsStudentViewLazy />} />,
		children: [],
	};
};
